import { LUISelectProps, OptionType, Select, ValueType } from '@lendi-ui/dropdown';
import Field from '@lendi-ui/field';
import styled, { css } from 'styled-components';
import getColour from '@lendi-ui/commons/colours';

import { PII_FIELD_MASKING_CLASS } from '@funnels/constants';
import { EventTracking } from '@funnels/types';
import { getAriaLabelById, getSelectedValue } from '@funnels/utils';

import { FieldLabel } from '../../_common/FieldLabel';
import { FieldWrapper } from '../../_common/style';

export interface UncontrolledDropdownFieldProps extends EventTracking, Omit<LUISelectProps, 'name' | 'value'> {
  label?: string;
  subLabel?: string;
  value?: string | string[];
  onChange?: (value: any) => void;
  isSearchable?: boolean;
  shouldAnchorList?: boolean;
  isOptional?: boolean;
  maskInFullStory?: boolean;
}

function UncontrolledDropdownField(props: UncontrolledDropdownFieldProps) {
  const {
    'data-component': dataComponent,
    isDisabled,
    isOptional,
    isError,
    label,
    onChange,
    options,
    subLabel,
    value,
    'aria-labelledby': ariaLabelledby,
    'aria-describedby': ariaDescribedby,
    isSearchable,
    shouldAnchorList,
    maskInFullStory,
    ...otherProps
  } = props;

  const luiProps: any = {
    ...otherProps,
    isDisabled,
  };

  function handleChange(values: ValueType<OptionType>) {
    let selected: string | string[] = otherProps.isMultiple ? [] : '';
    if (values) {
      if (otherProps.isMultiple && Array.isArray(values)) {
        selected = values.map((v) => v.value);
      } else {
        selected = Array.isArray(values) ? values[0].value : (values as any).value;
      }
    }

    if (onChange) {
      onChange(selected);
    }
  }

  if (shouldAnchorList) {
    luiProps.menuPortalTarget = document.querySelector('body');
    luiProps.menuPosition = 'absolute';
  }

  return (
    <FieldWrapper>
      <FieldLabel label={label} subLabel={subLabel} idPostfix={dataComponent} isOptional={isOptional} />
      <Field data-component={dataComponent} className={maskInFullStory ? PII_FIELD_MASKING_CLASS : ''}>
        <Select
          {...luiProps}
          size="md"
          value={getSelectedValue(options, value)}
          onChangeItem={handleChange}
          options={options}
          isError={isError}
          isSearchable={isSearchable}
          isFullWidth
          isOptionsOverflow
          aria-labelledby={getAriaLabelById('label', label ? dataComponent : undefined, ariaLabelledby)}
          aria-describedby={getAriaLabelById('description', subLabel ? dataComponent : undefined, ariaDescribedby)}
        />
      </Field>
    </FieldWrapper>
  );
}

export default UncontrolledDropdownField;
